const Module1Config = {
  day1: {
    learn: {
      video: 'ed04562696d62464b41c75b9b52c/480.m3u8',
      song: 'appfiles/eye_contact/school_photo_montage_music_1.m4a',
      json: 'appfiles/eye_contact/school_photo_montage_data_1.json',
    },
    celebrate: {
      video: 'c8ef87c9aba3630c193e35ba005a/480.m3u8',
    },
    rewardOption1: 'SurfBoardBlue',
    rewardOption2: 'SurfBoardRed',
  },
  day2: {
    learn: {
      video: 'b2a7ab4ccc38097bbc218e53bcd6/480.m3u8',
      song: 'appfiles/eye_contact/school_photo_montage_music_2.m4a',
      json: 'appfiles/eye_contact/school_photo_montage_data_2.json',
    },
    celebrate: {
      video: 'a9e6c2c8047789645f4cf5f74a08/480.m3u8',
    },
    rewardOption1: 'UmbrellaRed',
    rewardOption2: 'UmbrellaGreen',
  },
  day3: {
    learn: {
      video: 'a25af8fc729b5b88079b7c24a248/480.m3u8',
      song: 'appfiles/eye_contact/school_photo_montage_music_3.m4a',
      json: 'appfiles/eye_contact/school_photo_montage_data_3.json',
    },
    celebrate: {
      video: '016a8703b626ebffb5afb4392c89/480.m3u8',
    },
    rewardOption1: 'BeachChairRed',
    rewardOption2: 'BeachChairBlue',
  },
  day4: {
    introVideo: '2d4af24a51a1cae4a761a10f169d/480.m3u8',
    rewardOption2: 'FloatationInnerTube',
    rewardOption1: 'FloatationBall',
    photoTime: {
      video1: 'fba94ab8d25b0852d47ebba97091/480.m3u8',
      video2: '0ed90e516bca9e008a288386694e/480.m3u8',
    },
    singingTime: {
      intro: 'b24c63a9133b928a2aff40a46578/480.m3u8',
      demoMusic: 'appfiles/eye_contact/eye_contact_student_demo.m4a',
      singAlongMusic: 'appfiles/eye_contact/eye_contact_student_singalong.m4a',
      instrumentalMusic:
        'appfiles/eye_contact/eye_contact_student_instrumental.m4a',
      singingAlongVideo:
        'appfiles/eye_contact/eye_contact_singingtime_singalong.mp4',
      instrumentalVideo:
        'appfiles/eye_contact/eye_contact_singingtime_instrumental.mp4',
    },
  },
  day5: {
    introVideo: '88dffb9cdf934de3be264d5e6f68/480.m3u8',
    rewardOption1: 'OceanBoat',
    rewardOption2: 'OceanWhale',
    learn: {
      recording: 'userfiles/{student-id}/eye_contact_play_day_music.m4a',
      video: 'influencers/{influencer-id}/greet_affirmation.mp4',
      song: 'appfiles/eye_contact/eye_contact_student_instrumental.m4a',
      demoSong: 'appfiles/eye_contact/eye_contact_student_singalong.m4a',
      json: 'appfiles/eye_contact/school_photo_montage_data_5.json',
    },
    celebrate: {
      video: 'fc674bdd31fb420203b113833aef/480.m3u8',
      afterVideo: 'd61d88c0edcb8994c35981935c25/480.m3u8',
      animal: true,
      text: 'Record yourself in an excited voice and say, "I am awesome!"',
      name: 'eye_contact_celebration_surprise_5.mp4',
    },
  },
  day6: {
    rewardOption2: 'SandCastle',
    rewardOption1: 'SandBucket',
    learn: {
      video: 'influencers/{influencer-id}/greet_affirmation.mp4',
      song: 'appfiles/eye_contact/eye_contact_student_instrumental.m4a',
      recording: 'userfiles/{student-id}/eye_contact_play_day_music.m4a',
      demoSong: 'appfiles/eye_contact/eye_contact_student_singalong.m4a',
      json: 'appfiles/eye_contact/school_photo_montage_data_6.json',
    },
    celebrate: {
      video: 'e2072cb090c36af0abe1bdd8cb37/480.m3u8',
      afterVideo: '70a8af9da676d1e2d0c111ba4544/480.m3u8',
      animal: true,
      text: 'Record yourself in a funny voice and say, "I am awesome!"',
      name: 'eye_contact_celebration_surprise_6.mp4',
    },
  },
  day7: {
    rewardOption2: 'SeashellsGreen',
    rewardOption1: 'SeashellsRed',
    learn: {
      video: 'influencers/{influencer-id}/greet_affirmation.mp4',
      song: 'appfiles/eye_contact/eye_contact_student_instrumental.m4a',
      recording: 'userfiles/{student-id}/eye_contact_play_day_music.m4a',
      demoSong: 'appfiles/eye_contact/eye_contact_student_singalong.m4a',
      json: 'appfiles/eye_contact/school_photo_montage_data_7.json',
    },
    celebrate: {
      video: 'b949a41b3a8653748b9792d0ec00/480.m3u8',
      afterVideo: '70ec6497136acef3de79f4394b45/480.m3u8',
      animal: true,
      text: 'Record yourself singing, "I am awesome!"',
      name: 'eye_contact_celebration_surprise_7.mp4',
    },
  },
  day8: {
    rewardOption2: 'BeachwearSnorkle',
    rewardOption1: 'BeachwearSandles',
    learn: {
      video: 'influencers/{influencer-id}/greet_affirmation.mp4',
      recording: 'userfiles/{student-id}/eye_contact_play_day_music.m4a',
      song: 'appfiles/eye_contact/eye_contact_student_instrumental.m4a',
      demoSong: 'appfiles/eye_contact/eye_contact_student_singalong.m4a',
      json: 'appfiles/eye_contact/school_photo_montage_data_8.json',
    },
    celebrate: {
      video: '98129652a01c86c690da2c9a80a5/480.m3u8',
      afterVideo: 'e8da538190ec465aff45a30f9949/480.m3u8',
      animal: true,
      text: 'Record yourself making a silly face and say, "I am awesome!"',
      name: 'eye_contact_celebration_surprise_8.mp4',
    },
  },
  day9: {
    conclusionVideo: '49d22d9aeb814755bacd88ca7586/480.m3u8',
    rewardOption2: 'CrabWearMustache',
    rewardOption1: 'CrabWearGlasses',
    learn: {
      video: 'influencers/{influencer-id}/greet_affirmation.mp4',
      song: 'appfiles/eye_contact/eye_contact_student_instrumental.m4a',
      recording: 'userfiles/{student-id}/eye_contact_play_day_music.m4a',
      demoSong: 'appfiles/eye_contact/eye_contact_student_singalong.m4a',
      json: 'appfiles/eye_contact/school_photo_montage_data_9.json',
    },
    celebrate: {
      video: '58490af4c40d8d29547015ab78ad/480.m3u8',
      afterVideo: null,
      animal: true,
      text: 'Record yourself dancing and say, "I am awesome!"',
      name: 'eye_contact_celebration_surprise_9.mp4',
    },
    surprise: {
      video: 'd6c6b74e964a62fe8a9940bd860c/480.m3u8',
      song: 'appfiles/eye_contact/eye_contact_student_instrumental.m4a',
      slides: [
        'influencers/{influencer-id}/greet_affirmation.mp4',
        'userfiles/{student-id}/eye_contact_celebration_surprise_5.mp4',
        'userfiles/{student-id}/eye_contact_smile.jpg',
        'influencers/{influencer-id}/eye_contact_video_message.mp4',
        'userfiles/{student-id}/eye_contact_celebration_surprise_8.mp4',
        'userfiles/{student-id}/eye_contact_silly_photo_1.jpg',
        'userfiles/{student-id}/eye_contact_celebration_surprise_9.mp4',
      ],
    },
  },
};

export default Module1Config;
